import { IUserLogin, IUserLoginRes } from '../interfaces/login';
import * as baseAdapter from './baseAdapter';

export const login = async (body: IUserLogin) => {
  const ret = await baseAdapter.post<IUserLoginRes>('/authenicate/login', body);
  return ret.data;
};

export const authenicateCode = async (body: IUserLogin) => {
  const ret = await baseAdapter.post<boolean>(
    '/authenicate/SendVerificationCode',
    body,
  );
  return ret.data;
};
